import { Link, useParams } from 'react-router-dom'
import AdminTestViewer from '../../components/admin/AdminTestViewer'

const AdminTestDetailPage = () => {
  const { paperId } = useParams()
  const id = Number(paperId)

  if (!paperId || Number.isNaN(id) || id <= 0) {
    return (
      <div className="space-y-3">
        <p className="text-red-600">ID bài test không hợp lệ.</p>
        <Link to="/admin/tests" className="text-m2-primary hover:underline">
          ← Quay lại danh sách bài test
        </Link>
      </div>
    )
  }

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <Link
            to="/admin/tests"
            className="text-sm font-medium text-m2-primary hover:underline"
          >
            ← Danh sách bài test
          </Link>
          <h1 className="mt-1 text-2xl font-bold text-m2-on-surface">Chi tiết bài test #{id}</h1>
        </div>
        <Link
          to={`/admin/tests/${id}/edit`}
          className="rounded-lg bg-m2-primary px-4 py-2 text-sm font-semibold text-m2-on-primary"
        >
          Soạn đề
        </Link>
      </div>

      <div className="rounded-xl border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-950">
        <p className="font-semibold">Cách gắn skill Ask AI</p>
        <ol className="mt-1 list-decimal space-y-0.5 pl-4 text-amber-900/90">
          <li>Ở khung xanh bên dưới: gắn skill dùng chung cho cả bài test.</li>
          <li>Hoặc mở từng câu → nút “Gắn skill câu” để gắn skill riêng câu đó.</li>
        </ol>
        <p className="mt-2 text-xs text-amber-800">
          Menu: Admin → <strong>Quản lý bài test</strong> → chọn đề → Gắn skill / Xem đề
        </p>
      </div>

      <AdminTestViewer paperId={id} />
    </div>
  )
}

export default AdminTestDetailPage
